import * as React from "react";
const SvgCClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 5L5 19M19 19L5 5", stroke: "#currentColor", strokeWidth: 1.5 }));
export default SvgCClose;
